import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Card, Table, Badge,Col } from "react-bootstrap";
import CountUp from "react-countup";

// Images
import ic_stat1 from "../../../images/svg/ic_stat1.svg";
import ic_stat2 from "../../../images/svg/ic_stat2.svg";
import OrderSummaryChart from "../davur/home/OrdersSummaryChart";
import RevenueChart from "../davur/home/RevenueChart";
import ActiveChart1 from "../davur/home/ActivityChart1";
import ActiveChart2 from "../davur/home/ActivityChart2";
import ActiveChart3 from "../davur/home/ActivityChart3";
import DealIcon from "../../../images/deal-icon.png";
import RevenueIcon from "../../../images/coin-1.png";
import { useState } from "react";
import { dashboard } from "../../../services/AuthService";
import { useEffect } from "react";

// import avatar3 from "../../../images/avatar/3.jpg";
// import avatar4 from "../../../images/avatar/4.jpg";
// import svg from "../../../images/svg/welcom-card.svg";

// import { Dropdown, Nav, Tab } from "react-bootstrap";
// import LineChart7 from "../charts/Chartjs/line7";
// import BarChart7 from "../charts/Chartjs/bar7";
// const ApexPie3 = loadable(() =>
//    pMinDelay(import("../charts/apexcharts/Pie3"), 1000)
// );

const Home = (props) => {
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
const [banner, setBanner] = useState('');
const [revenue, setRevenue] = useState('');
const [user, setUser] = useState('');
const [vendor, setVendor] = useState('');
function handleFetch(){
  dashboard().then((response)=>{
    setBanner(response.data.data[0].data1);
    setRevenue(response.data.data[1].data2);
    setUser(response.data.data[2].data3);
    setVendor(response.data.data[3].data4);
    console.log(response.data.data[0].data1,"response")
  }).catch((error)=>{
    if (error.response.data.statusCode === 401) {
      localStorage.clear("tokenDetails");
      props.history.push("/login");
    }
  })
}
useEffect(()=>{
  handleFetch();
},[])
  return (
    <>
      <div className="form-head d-flex mb-3 align-items-start">
        <div className="mr-auto d-none d-lg-block">
          <h2 className="text-black font-w600 mb-0">Dashboard</h2>
          <p className="mb-0">Welcome to Pushyy Admin Panel </p>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-3 col-xxl-3 col-lg-6 col-md-6 col-sm-6">
          <div className="widget-stat card">
            <div className="card-body p-4">
              <div className="media ai-icon">
                <span className="mr-3 bgl-primary text-primary">
                  {/* <i class="ti-user"></i> */}
                  <img src={DealIcon} style={{ width: "60%" }} />
                  {/* <svg
                    width={36}
                    height={28}
                    viewBox="0 0 36 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M31.75 6.75H30.0064L30.2189 4.62238C30.2709 4.10111 30.2131 3.57473 30.0493 3.07716C29.8854 2.57959 29.6192 2.12186 29.2676 1.73348C28.9161 1.3451 28.4871 1.03468 28.0082 0.822231C27.5294 0.609781 27.0114 0.500013 26.4875 0.5H7.0125C6.48854 0.500041 5.9704 0.609864 5.49148 0.822391C5.01256 1.03492 4.58348 1.34543 4.23189 1.73392C3.88031 2.12241 3.61403 2.58026 3.45021 3.07795C3.28639 3.57564 3.22866 4.10214 3.28075 4.6235L5.2815 24.6224C5.31508 24.9222 5.38467 25.2168 5.48875 25.5H1.75C1.41848 25.5 1.10054 25.6317 0.866116 25.8661C0.631696 26.1005 0.5 26.4185 0.5 26.75C0.5 27.0815 0.631696 27.3995 0.866116 27.6339C1.10054 27.8683 1.41848 28 1.75 28H31.75C32.0815 28 32.3995 27.8683 32.6339 27.6339C32.8683 27.3995 33 27.0815 33 26.75C33 26.4185 32.8683 26.1005 32.6339 25.8661C32.3995 25.6317 32.0815 25.5 31.75 25.5H28.0115C28.1154 25.2172 28.1849 24.9229 28.2185 24.6235L28.881 18H31.75C32.7442 17.9989 33.6974 17.6035 34.4004 16.9004C35.1035 16.1974 35.4989 15.2442 35.5 14.25V10.5C35.4989 9.50577 35.1035 8.55258 34.4004 7.84956C33.6974 7.14653 32.7442 6.75109 31.75 6.75ZM9.0125 25.5C8.70243 25.501 8.40314 25.3862 8.17327 25.1782C7.9434 24.9701 7.79949 24.6836 7.76975 24.375L5.7685 4.37575C5.75109 4.20188 5.7703 4.0263 5.82488 3.86031C5.87946 3.69432 5.96821 3.5416 6.0854 3.412C6.2026 3.28239 6.34564 3.17877 6.50532 3.10781C6.665 3.03685 6.83777 3.00013 7.0125 3H26.4875C26.6622 3.00012 26.8349 3.03681 26.9945 3.10772C27.1541 3.17863 27.2972 3.28218 27.4143 3.4117C27.5315 3.54123 27.6203 3.69386 27.6749 3.85977C27.7295 4.02568 27.7488 4.20119 27.7315 4.375L25.7308 24.3762C25.7007 24.6848 25.5566 24.971 25.3267 25.1788C25.0967 25.3867 24.7975 25.5012 24.4875 25.5H9.0125ZM33 14.25C32.9998 14.5815 32.868 14.8993 32.6337 15.1337C32.3993 15.368 32.0815 15.4998 31.75 15.5H29.1311L29.7561 9.25H31.75C32.0815 9.2502 32.3993 9.38196 32.6337 9.61634C32.868 9.85071 32.9998 10.1685 33 10.5V14.25Z"
                      fill="#2F4CDD"
                    />
                  </svg> */}
                </span>
                <div className="media-body">
                  <h3 className="mb-0 text-black">
                    <span className="counter ml-0">
                      <CountUp start={0} end={banner} duration={5} />
                    </span>
                  </h3>
                  <p className="mb-0">Total Banner Purchased</p>
                  {/* <small>4% (30 days)</small> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-xxl-3 col-lg-6 col-md-6 col-sm-6">
          <div className="widget-stat card">
            <div className="card-body p-4">
              <div className="media ai-icon">
                <span className="mr-3 bgl-primary text-primary">
                  {/* <i class="ti-user"></i> */}
                  <img src={RevenueIcon} style={{ width: "60%" }} />
                  {/* <svg
                    width={20}
                    height={36}
                    viewBox="0 0 20 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.08 24.36C19.08 25.64 18.76 26.8667 18.12 28.04C17.48 29.1867 16.5333 30.1467 15.28 30.92C14.0533 31.6933 12.5733 32.1333 10.84 32.24V35.48H8.68V32.24C6.25333 32.0267 4.28 31.2533 2.76 29.92C1.24 28.56 0.466667 26.84 0.44 24.76H4.32C4.42667 25.88 4.84 26.8533 5.56 27.68C6.30667 28.5067 7.34667 29.0267 8.68 29.24V19.24C6.89333 18.7867 5.45333 18.32 4.36 17.84C3.26667 17.36 2.33333 16.6133 1.56 15.6C0.786667 14.5867 0.4 13.2267 0.4 11.52C0.4 9.36 1.14667 7.57333 2.64 6.16C4.16 4.74666 6.17333 3.96 8.68 3.8V0.479998H10.84V3.8C13.1067 3.98667 14.9333 4.72 16.32 6C17.7067 7.25333 18.5067 8.89333 18.72 10.92H14.84C14.7067 9.98667 14.2933 9.14667 13.6 8.4C12.9067 7.62667 11.9867 7.12 10.84 6.88V16.64C12.6 17.0933 14.0267 17.56 15.12 18.04C16.24 18.4933 17.1733 19.2267 17.92 20.24C18.6933 21.2533 19.08 22.6267 19.08 24.36ZM4.12 11.32C4.12 12.6267 4.50667 13.6267 5.28 14.32C6.05333 15.0133 7.18667 15.5867 8.68 16.04V6.8C7.29333 6.93333 6.18667 7.38667 5.36 8.16C4.53333 8.90667 4.12 9.96 4.12 11.32ZM10.84 29.28C12.28 29.12 13.4 28.6 14.2 27.72C15.0267 26.84 15.44 25.7867 15.44 24.56C15.44 23.2533 15.04 22.2533 14.24 21.56C13.44 20.84 12.3067 20.2667 10.84 19.84V29.28Z"
                      fill="#2F4CDD"
                    />
                  </svg> */}
                </span>
                <div className="media-body">
                  <h3 className="mb-0 text-black">
                    <span className="counter ml-0">
                      {" "}
                      <CountUp start={0} end={revenue} duration={5} />
                    </span>
                  </h3>
                  <p className="mb-0">Total Revenue ($)</p>
                  {/* <small>4% (30 days)</small> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-xxl-3 col-lg-6 col-md-6 col-sm-6">
          <div className="widget-stat card">
            <div className="card-body p-4">
              <div className="media ai-icon">
                <span className="mr-3 bgl-primary text-primary">
                  {/* <i class="ti-user"></i> */}
                  <svg
                    width={32}
                    height={36}
                    viewBox="0 0 32 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.25 19.25C12.2389 19.25 13.2056 18.9568 14.0279 18.4074C14.8501 17.8579 15.491 17.0771 15.8694 16.1634C16.2478 15.2498 16.3469 14.2445 16.1539 13.2746C15.961 12.3046 15.4848 11.4137 14.7855 10.7145C14.0863 10.0152 13.1954 9.539 12.2255 9.34608C11.2555 9.15315 10.2502 9.25217 9.33658 9.6306C8.42295 10.009 7.64206 10.6499 7.09265 11.4722C6.54325 12.2944 6.25 13.2611 6.25 14.25C6.25129 15.5757 6.77849 16.8467 7.71589 17.7841C8.65329 18.7215 9.92431 19.2487 11.25 19.25ZM11.25 11.75C11.7445 11.75 12.2278 11.8966 12.6389 12.1713C13.05 12.446 13.3705 12.8365 13.5597 13.2933C13.7489 13.7501 13.7984 14.2528 13.702 14.7377C13.6055 15.2227 13.3674 15.6681 13.0178 16.0178C12.6681 16.3674 12.2227 16.6055 11.7377 16.702C11.2528 16.7984 10.7501 16.7489 10.2933 16.5597C9.83648 16.3705 9.44603 16.0501 9.17133 15.6389C8.89662 15.2278 8.75 14.7445 8.75 14.25C8.75089 13.5872 9.01457 12.9519 9.48322 12.4832C9.95187 12.0146 10.5872 11.7509 11.25 11.75Z"
                      fill="#3C94E6"
                    />
                    <path
                      d="M30.78 22.4625C31.1927 21.9098 31.4684 21.2672 31.5844 20.5873C31.7005 19.9074 31.6537 19.2096 31.4478 18.5514L30.6543 15.9696C30.2817 14.7451 29.5244 13.6733 28.4946 12.9132C27.4648 12.1531 26.2174 11.7452 24.9375 11.75H19.3287C18.9971 11.75 18.6792 11.8817 18.4448 12.1161C18.2103 12.3505 18.0787 12.6685 18.0787 13C18.0787 13.3315 18.2103 13.6495 18.4448 13.8839C18.6792 14.1183 18.9971 14.25 19.3287 14.25H24.9375C25.6823 14.2474 26.4081 14.485 27.0073 14.9274C27.6064 15.3698 28.0471 15.9935 28.2639 16.706L29.0574 19.2866C29.145 19.5713 29.1645 19.8725 29.1145 20.1661C29.0645 20.4597 28.9463 20.7374 28.7694 20.977C28.5925 21.2166 28.3619 21.4114 28.0961 21.5456C27.8302 21.6799 27.5366 21.7499 27.2388 21.75H15.7777C15.7423 21.75 15.7127 21.7671 15.6777 21.7701C15.5937 21.7669 15.5125 21.75 15.4273 21.75H7.58978C6.20071 21.7449 4.84705 22.1879 3.72972 23.0132C2.61239 23.8385 1.79097 25.0021 1.3874 26.3312L0.454153 29.3625C0.236164 30.0719 0.187639 30.8225 0.31248 31.554C0.43732 32.2856 0.732043 32.9776 1.17296 33.5745C1.61388 34.1715 2.18869 34.6566 2.85119 34.9911C3.51369 35.3255 4.24541 35.4998 4.98753 35.5H18.0287C18.7708 35.4998 19.5026 35.3256 20.1652 34.9912C20.8277 34.6568 21.4026 34.1717 21.8436 33.5747C22.2845 32.9778 22.5793 32.2857 22.7042 31.5541C22.829 30.8226 22.7805 30.0719 22.5625 29.3625L21.6299 26.3315C21.3936 25.5767 21.0217 24.8713 20.5323 24.25H27.2388C27.9283 24.2532 28.6088 24.0928 29.2244 23.7821C29.8399 23.4714 30.3731 23.0191 30.78 22.4625ZM19.8328 32.089C19.6255 32.3726 19.3539 32.6031 19.0403 32.7614C18.7267 32.9198 18.38 33.0015 18.0287 33H4.98753C4.63653 32.9999 4.29043 32.9175 3.97708 32.7594C3.66373 32.6012 3.39187 32.3717 3.18337 32.0894C2.97487 31.807 2.83555 31.4796 2.77661 31.1336C2.71767 30.7876 2.74077 30.4326 2.84403 30.0971L3.77665 27.0661C4.02442 26.2489 4.52925 25.5335 5.21612 25.0261C5.90299 24.5188 6.73523 24.2466 7.58915 24.25H15.4267C16.2806 24.2466 17.1128 24.5188 17.7997 25.0261C18.4865 25.5335 18.9914 26.2489 19.2392 27.0661L20.1718 30.0971C20.2769 30.4323 20.301 30.7877 20.2421 31.134C20.1832 31.4804 20.0429 31.8078 19.8328 32.0894V32.089Z"
                      fill="#3C94E6"
                    />
                    <path
                      d="M21.875 9.24999C22.7403 9.24999 23.5861 8.9934 24.3056 8.51267C25.0251 8.03194 25.5858 7.34866 25.917 6.54923C26.2481 5.74981 26.3347 4.87014 26.1659 4.02148C25.9971 3.17281 25.5804 2.39326 24.9686 1.78141C24.3567 1.16955 23.5772 0.752876 22.7285 0.584066C21.8798 0.415256 21.0002 0.501896 20.2008 0.833029C19.4013 1.16416 18.7181 1.72492 18.2373 2.44438C17.7566 3.16384 17.5 4.0097 17.5 4.875C17.5014 6.03489 17.9628 7.14688 18.7829 7.96705C19.6031 8.78722 20.7151 9.2486 21.875 9.24999ZM21.875 3C22.2458 3 22.6083 3.10997 22.9167 3.31599C23.225 3.52202 23.4654 3.81485 23.6073 4.15747C23.7492 4.50008 23.7863 4.87708 23.714 5.24079C23.6416 5.6045 23.463 5.9386 23.2008 6.20082C22.9386 6.46304 22.6045 6.64162 22.2408 6.71397C21.8771 6.78631 21.5001 6.74918 21.1575 6.60727C20.8149 6.46535 20.522 6.22503 20.316 5.91669C20.11 5.60835 20 5.24584 20 4.875C20.0006 4.37789 20.1983 3.9013 20.5498 3.54979C20.9013 3.19829 21.3779 3.00056 21.875 3Z"
                      fill="#3C94E6"
                    />
                  </svg>
                </span>
                <div className="media-body">
                  <h3 className="mb-0 text-black">
                    <span className="counter ml-0">
                      {" "}
                      <CountUp start={0} end={user} duration={5} />
                    </span>
                  </h3>
                  <p className="mb-0">Total Users</p>
                  {/* <small>4% (30 days)</small> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3 col-xxl-3 col-lg-6 col-md-6 col-sm-6">
          <div className="widget-stat card">
            <div className="card-body p-4">
              <div className="media ai-icon">
                <span className="mr-3 bgl-primary text-primary">
                  {/* <i class="ti-user"></i> */}
                  <svg
                    width={32}
                    height={36}
                    viewBox="0 0 32 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.25 19.25C12.2389 19.25 13.2056 18.9568 14.0279 18.4074C14.8501 17.8579 15.491 17.0771 15.8694 16.1634C16.2478 15.2498 16.3469 14.2445 16.1539 13.2746C15.961 12.3046 15.4848 11.4137 14.7855 10.7145C14.0863 10.0152 13.1954 9.539 12.2255 9.34608C11.2555 9.15315 10.2502 9.25217 9.33658 9.6306C8.42295 10.009 7.64206 10.6499 7.09265 11.4722C6.54325 12.2944 6.25 13.2611 6.25 14.25C6.25129 15.5757 6.77849 16.8467 7.71589 17.7841C8.65329 18.7215 9.92431 19.2487 11.25 19.25ZM11.25 11.75C11.7445 11.75 12.2278 11.8966 12.6389 12.1713C13.05 12.446 13.3705 12.8365 13.5597 13.2933C13.7489 13.7501 13.7984 14.2528 13.702 14.7377C13.6055 15.2227 13.3674 15.6681 13.0178 16.0178C12.6681 16.3674 12.2227 16.6055 11.7377 16.702C11.2528 16.7984 10.7501 16.7489 10.2933 16.5597C9.83648 16.3705 9.44603 16.0501 9.17133 15.6389C8.89662 15.2278 8.75 14.7445 8.75 14.25C8.75089 13.5872 9.01457 12.9519 9.48322 12.4832C9.95187 12.0146 10.5872 11.7509 11.25 11.75Z"
                      fill="#3C94E6"
                    />
                    <path
                      d="M30.78 22.4625C31.1927 21.9098 31.4684 21.2672 31.5844 20.5873C31.7005 19.9074 31.6537 19.2096 31.4478 18.5514L30.6543 15.9696C30.2817 14.7451 29.5244 13.6733 28.4946 12.9132C27.4648 12.1531 26.2174 11.7452 24.9375 11.75H19.3287C18.9971 11.75 18.6792 11.8817 18.4448 12.1161C18.2103 12.3505 18.0787 12.6685 18.0787 13C18.0787 13.3315 18.2103 13.6495 18.4448 13.8839C18.6792 14.1183 18.9971 14.25 19.3287 14.25H24.9375C25.6823 14.2474 26.4081 14.485 27.0073 14.9274C27.6064 15.3698 28.0471 15.9935 28.2639 16.706L29.0574 19.2866C29.145 19.5713 29.1645 19.8725 29.1145 20.1661C29.0645 20.4597 28.9463 20.7374 28.7694 20.977C28.5925 21.2166 28.3619 21.4114 28.0961 21.5456C27.8302 21.6799 27.5366 21.7499 27.2388 21.75H15.7777C15.7423 21.75 15.7127 21.7671 15.6777 21.7701C15.5937 21.7669 15.5125 21.75 15.4273 21.75H7.58978C6.20071 21.7449 4.84705 22.1879 3.72972 23.0132C2.61239 23.8385 1.79097 25.0021 1.3874 26.3312L0.454153 29.3625C0.236164 30.0719 0.187639 30.8225 0.31248 31.554C0.43732 32.2856 0.732043 32.9776 1.17296 33.5745C1.61388 34.1715 2.18869 34.6566 2.85119 34.9911C3.51369 35.3255 4.24541 35.4998 4.98753 35.5H18.0287C18.7708 35.4998 19.5026 35.3256 20.1652 34.9912C20.8277 34.6568 21.4026 34.1717 21.8436 33.5747C22.2845 32.9778 22.5793 32.2857 22.7042 31.5541C22.829 30.8226 22.7805 30.0719 22.5625 29.3625L21.6299 26.3315C21.3936 25.5767 21.0217 24.8713 20.5323 24.25H27.2388C27.9283 24.2532 28.6088 24.0928 29.2244 23.7821C29.8399 23.4714 30.3731 23.0191 30.78 22.4625ZM19.8328 32.089C19.6255 32.3726 19.3539 32.6031 19.0403 32.7614C18.7267 32.9198 18.38 33.0015 18.0287 33H4.98753C4.63653 32.9999 4.29043 32.9175 3.97708 32.7594C3.66373 32.6012 3.39187 32.3717 3.18337 32.0894C2.97487 31.807 2.83555 31.4796 2.77661 31.1336C2.71767 30.7876 2.74077 30.4326 2.84403 30.0971L3.77665 27.0661C4.02442 26.2489 4.52925 25.5335 5.21612 25.0261C5.90299 24.5188 6.73523 24.2466 7.58915 24.25H15.4267C16.2806 24.2466 17.1128 24.5188 17.7997 25.0261C18.4865 25.5335 18.9914 26.2489 19.2392 27.0661L20.1718 30.0971C20.2769 30.4323 20.301 30.7877 20.2421 31.134C20.1832 31.4804 20.0429 31.8078 19.8328 32.0894V32.089Z"
                      fill="#3C94E6"
                    />
                    <path
                      d="M21.875 9.24999C22.7403 9.24999 23.5861 8.9934 24.3056 8.51267C25.0251 8.03194 25.5858 7.34866 25.917 6.54923C26.2481 5.74981 26.3347 4.87014 26.1659 4.02148C25.9971 3.17281 25.5804 2.39326 24.9686 1.78141C24.3567 1.16955 23.5772 0.752876 22.7285 0.584066C21.8798 0.415256 21.0002 0.501896 20.2008 0.833029C19.4013 1.16416 18.7181 1.72492 18.2373 2.44438C17.7566 3.16384 17.5 4.0097 17.5 4.875C17.5014 6.03489 17.9628 7.14688 18.7829 7.96705C19.6031 8.78722 20.7151 9.2486 21.875 9.24999ZM21.875 3C22.2458 3 22.6083 3.10997 22.9167 3.31599C23.225 3.52202 23.4654 3.81485 23.6073 4.15747C23.7492 4.50008 23.7863 4.87708 23.714 5.24079C23.6416 5.6045 23.463 5.9386 23.2008 6.20082C22.9386 6.46304 22.6045 6.64162 22.2408 6.71397C21.8771 6.78631 21.5001 6.74918 21.1575 6.60727C20.8149 6.46535 20.522 6.22503 20.316 5.91669C20.11 5.60835 20 5.24584 20 4.875C20.0006 4.37789 20.1983 3.9013 20.5498 3.54979C20.9013 3.19829 21.3779 3.00056 21.875 3Z"
                      fill="#3C94E6"
                    />
                  </svg>
                </span>
                <div className="media-body">
                  <h3 className="mb-0 text-black">
                    <span className="counter ml-0">
                      {" "}
                      <CountUp start={0} end={vendor} duration={5} />
                    </span>
                  </h3>
                  <p className="mb-0">Total Vendors</p>
                  {/* <small>4% (30 days)</small> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-xl-6 col-xxl-6 col-lg-12 col-md-12">
          <Tab.Container defaultActiveKey="monthly">
            <div className="card">
              <div className="card-header border-0 pb-0 d-sm-flex d-block">
                <div>
                  <h4 className="card-title mb-1">Orders Summary</h4>
                  <small className="mb-0">
                    Lorem ipsum dolor sit amet, consectetur
                  </small>
                </div>
                <div className="card-action card-tabs mt-3 mt-sm-0">
                  <Nav as="ul" className="nav nav-tabs" role="tablist">
                    <Nav.Item className="nav-item">
                      <Nav.Link
                        className="nav-link"
                        data-toggle="tab"
                        to="#bounce"
                        role="tab"
                        eventKey="monthly"
                      >
                        Monthly
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item">
                      <Nav.Link
                        className="nav-link"
                        data-toggle="tab"
                        to="#bounce"
                        role="tab"
                        eventKey="weekly"
                      >
                        Weekly
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item">
                      <Nav.Link
                        className="nav-link"
                        data-toggle="tab"
                        to="#session-duration"
                        role="tab"
                        eventKey="today"
                      >
                        Today
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
              <div className="card-body orders-summary">
                <Tab.Content>
                  <Tab.Pane eventKey="monthly"></Tab.Pane>
                  <Tab.Pane eventKey="weekly"></Tab.Pane>
                  <Tab.Pane eventKey="today"></Tab.Pane>
                  <div className="d-flex order-manage p-3 align-items-center mb-4">
                    <Link
                      to="#"
                      className="btn fs-22 py-1 btn-success px-4 mr-3"
                    >
                      25
                    </Link>
                    <h4 className="mb-0">
                      New Orders{" "}
                      <i className="fa fa-circle text-success ml-1 fs-15" />
                    </h4>
                    <Link to="#" className="ml-auto text-primary font-w500">
                      Manage orders <i className="ti-angle-right ml-1" />
                    </Link>
                  </div>
                  <div className="row">
                    <div className="col-sm-4 mb-4">
                      <div className="border px-3 py-3 rounded-xl">
                        <h2 className="fs-32 font-w600 counter">
                          <CountUp start={0} end={25} duration={5} />
                        </h2>
                        <p className="fs-16 mb-0">On Delivery</p>
                      </div>
                    </div>
                    <div className="col-sm-4 mb-4">
                      <div className="border px-3 py-3 rounded-xl">
                        <h2 className="fs-32 font-w600 counter">
                          <CountUp start={0} end={60} duration={5} />
                        </h2>
                        <p className="fs-16 mb-0">Delivered</p>
                      </div>
                    </div>
                    <div className="col-sm-4 mb-4">
                      <div className="border px-3 py-3 rounded-xl">
                        <h2 className="fs-32 font-w600 counter">
                          <CountUp start={0} end={7} duration={5} />
                        </h2>
                        <p className="fs-16 mb-0">Canceled</p>
                      </div>
                    </div>
                  </div>
                  <div className="widget-timeline-icon">
                    <div className="row align-items-center">
                      <div className="col-xl-3 col-lg-2 col-xxl-4 col-sm-3 col-md-3 my-2 text-center text-sm-left">
                        {/* <div id="chart" className="d-inline-block" /> 
                        <OrderSummaryChart />
                      </div>
                      <div className="col-xl-9 col-lg-10 col-xxl-8 col-sm-9 col-md-9">
                        <div className="d-flex align-items-center mb-3">
                          <p className="mb-0 fs-14 mr-2 col-4 col-xxl-5 px-0">
                            Immunities (24%)
                          </p>
                          <div
                            className="progress mb-0"
                            style={{ height: 8, width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-warning progress-animated"
                              style={{ width: "85%", height: 8 }}
                              role="progressbar"
                            >
                              <span className="sr-only">60% Complete</span>
                            </div>
                          </div>
                          <span className="pull-right ml-auto col-1 col-xxl-2 px-0 text-right">
                            25
                          </span>
                        </div>
                        <div className="d-flex align-items-center  mb-3">
                          <p className="mb-0 fs-14 mr-2 col-4 col-xxl-5 px-0">
                            Heart Beat (41%)
                          </p>
                          <div
                            className="progress mb-0"
                            style={{ height: 8, width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-success progress-animated"
                              style={{ width: "70%", height: 8 }}
                              role="progressbar"
                            >
                              <span className="sr-only">60% Complete</span>
                            </div>
                          </div>
                          <span className="pull-right ml-auto col-1 col-xxl-2 px-0 text-right">
                            60
                          </span>
                        </div>
                        <div className="d-flex align-items-center">
                          <p className="mb-0 fs-14 mr-2 col-4 col-xxl-5 px-0">
                            Weigth (15%)
                          </p>
                          <div
                            className="progress mb-0"
                            style={{ height: 8, width: "100%" }}
                          >
                            <div
                              className="progress-bar bg-dark progress-animated"
                              style={{ width: "30%", height: 8 }}
                              role="progressbar"
                            >
                              <span className="sr-only">60% Complete</span>
                            </div>
                          </div>
                          <span className="pull-right ml-auto col-1 col-xxl-2 px-0 text-right">
                            07
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </div>
        <div className="col-xl-6 col-xxl-6 col-lg-12 col-md-12">
          <div className="card">
            <div className="card-header border-0 pb-0 d-sm-flex d-block">
              <div>
                <h4 className="card-title mb-1">Revenue</h4>
                <small className="mb-0">
                  Lorem ipsum dolor sit amet, consectetur
                </small>
              </div>
              <Dropdown className="dropdown mt-3 mt-sm-0">
                <Dropdown.Toggle
                  type="button"
                  className="btn btn-primary dropdown-toggle light fs-14"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  Weekly
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu">
                  <Dropdown.Item className="dropdown-item" to="#">
                    Daily
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item" to="#">
                    Weekly
                  </Dropdown.Item>
                  <Dropdown.Item className="dropdown-item" to="#">
                    Monthly
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="card-body revenue-chart px-3">
              <div className="d-flex align-items-end pr-3 pull-right revenue-chart-bar">
                <div className="d-flex align-items-end mr-4">
                  <img
                    src={ic_stat2}
                    height={22}
                    width={22}
                    className="mr-2 mb-1"
                    alt="ic_stat2"
                  />
                  <div>
                    <small className="text-dark fs-14">Income</small>
                    <h3 className="font-w600 mb-0">
                      $
                      <span className="counter">
                        <CountUp start={0} end={41512} duration={5} />
                      </span>
                      k
                    </h3>
                  </div>
                </div>
                <div className="d-flex align-items-end">
                  <img
                    src={ic_stat1}
                    height={22}
                    width={22}
                    className="mr-2 mb-1"
                    alt="ic_stat1"
                  />
                  <div>
                    <small className="text-dark fs-14">Expense</small>
                    <h3 className="font-w600 mb-0">
                      $
                      <span className="counter">
                        <CountUp start={0} end={41512} duration={5} />
                      </span>
                      k
                    </h3>
                  </div>
                </div>
              </div>
              <div id="chartBar">
                {/* <h1>Set A Chart Here</h1> 
                <RevenueChart />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-xxl-9 col-lg-8 col-md-12">
          <Tab.Container defaultActiveKey="monthly">
            <div id="user-activity" className="card">
              <div className="card-header border-0 pb-0 d-sm-flex d-block">
                <div>
                  <h4 className="card-title mb-1">Customer Map</h4>
                  <small className="mb-0">
                    Lorem Ipsum is simply dummy text of the printing
                  </small>
                </div>
                <div className="card-action card-tabs mt-3 mt-sm-0">
                  <Nav className="nav nav-tabs" role="tablist">
                    <Nav.Item className="nav-item">
                      <Nav.Link
                        className="nav-link "
                        data-toggle="tab"
                        to="#user"
                        role="tab"
                        eventKey="monthly"
                      >
                        Monthly
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item">
                      <Nav.Link
                        className="nav-link"
                        data-toggle="tab"
                        to="#bounce"
                        role="tab"
                        eventKey="weekly"
                      >
                        Weekly
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="nav-item">
                      <Nav.Link
                        className="nav-link"
                        data-toggle="tab"
                        to="#session-duration"
                        role="tab"
                        eventKey="today"
                      >
                        Today
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
              <div className="card-body">
                <Tab.Content className="tab-content">
                  <Tab.Pane eventKey="monthly">
                    <ActiveChart1 />
                  </Tab.Pane>
                  <Tab.Pane eventKey="weekly">
                    <ActiveChart2 />
                  </Tab.Pane>
                  <Tab.Pane eventKey="today">
                    <ActiveChart3 />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </div>
        <div className="col-xl-3 col-xxl-3 col-lg-4 col-md-12">
          <div
            className="card bg-secondary"
            style={{
              backgroundImage: "url(images/bg-icon.png)",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top right",
            }}
          >
            <div className="card-body p-5 mt-3">
              <svg
                width={44}
                height={44}
                viewBox="0 0 44 44"
                className="mb-3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.9531 20.625H5.67188C2.54435 20.625 0 18.0806 0 14.9531V5.67188C0 2.54435 2.54435 0 5.67188 0H14.9531C18.0806 0 20.625 2.54435 20.625 5.67188V14.9531C20.625 18.0806 18.0806 20.625 14.9531 20.625ZM5.67188 2.75C4.06072 2.75 2.75 4.06072 2.75 5.67188V14.9531C2.75 16.5643 4.06072 17.875 5.67188 17.875H14.9531C16.5643 17.875 17.875 16.5643 17.875 14.9531V5.67188C17.875 4.06072 16.5643 2.75 14.9531 2.75H5.67188Z"
                  fill="#fff"
                />
                <path
                  d="M38.3281 20.625H29.0469C25.9194 20.625 23.375 18.0806 23.375 14.9531V5.67188C23.375 2.54435 25.9194 0 29.0469 0H38.3281C41.4556 0 44 2.54435 44 5.67188V14.9531C44 18.0806 41.4556 20.625 38.3281 20.625ZM29.0469 2.75C27.4357 2.75 26.125 4.06072 26.125 5.67188V14.9531C26.125 16.5643 27.4357 17.875 29.0469 17.875H38.3281C39.9393 17.875 41.25 16.5643 41.25 14.9531V5.67188C41.25 4.06072 39.9393 2.75 38.3281 2.75H29.0469Z"
                  fill="#fff"
                />
                <path
                  d="M33.6875 44C28.0012 44 23.375 39.3738 23.375 33.6875C23.375 28.0012 28.0012 23.375 33.6875 23.375C39.3738 23.375 44 28.0012 44 33.6875C44 39.3738 39.3738 44 33.6875 44ZM33.6875 26.125C29.5176 26.125 26.125 29.5176 26.125 33.6875C26.125 37.8574 29.5176 41.25 33.6875 41.25C37.8574 41.25 41.25 37.8574 41.25 33.6875C41.25 29.5176 37.8574 26.125 33.6875 26.125Z"
                  fill="#fff"
                />
                <path
                  d="M14.9531 44H5.67188C2.54435 44 0 41.4556 0 38.3281V29.0469C0 25.9194 2.54435 23.375 5.67188 23.375H14.9531C18.0806 23.375 20.625 25.9194 20.625 29.0469V38.3281C20.625 41.4556 18.0806 44 14.9531 44ZM5.67188 26.125C4.06072 26.125 2.75 27.4357 2.75 29.0469V38.3281C2.75 39.9393 4.06072 41.25 5.67188 41.25H14.9531C16.5643 41.25 17.875 39.9393 17.875 38.3281V29.0469C17.875 27.4357 16.5643 26.125 14.9531 26.125H5.67188Z"
                  fill="#fff"
                />
              </svg>
              <h4 className="text-white mb-3">
                Manage <br />
                dashboard layout
              </h4>
              <Link
                to="#"
                className="d-flex text-light align-items-center justify-content-between"
              >
                <small>Lorem ipsum dolor sit amet, consectetur</small>
                <i className="ti-arrow-right" />
              </Link>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Home;
